module.exports = {
  check_role (value) {
    var user = []

    /* const ls = require('local-storage')
    var _userlogado = ls.get('role')
    switch (value) {
      case 'ped':
        const _dataped = [{ 'role': 'ROLE_PED' }, { 'role': 'ROLE_ADM' }, { 'role': 'ROLE_DIR' }, { 'role': 'ROLE_POW' }]
        user = _dataped.filter(t => t.role === _userlogado)

        break
      case 'prof':
        const _dataprof = [{ 'role': 'ROLE_PROF' }, { 'role': 'ROLE_PED' }, { 'role': 'ROLE_ADM' }, { 'role': 'ROLE_DIR' }, { 'role': 'ROLE_POW' }, { 'role': 'ROLE_FUNC' }, { 'role': 'ROLE_COOR' }]
        user = _dataprof.filter(t => t.role === _userlogado)

        break
      case 'adm':
        const _dataadm = [{ 'role': 'ROLE_ADM' }]
        user = _dataadm.filter(t => t.role === _userlogado)
        break
      case 'est':
        const _dataest = [{ 'role': 'ROLE_EST' }, { 'role': 'ROLE_PROF' }, { 'role': 'ROLE_PED' }, { 'role': 'ROLE_ADM' }, { 'role': 'ROLE_DIR' }, { 'role': 'ROLE_COOR' }, { 'role': 'ROLE_POW' }, { 'role': 'ROLE_FUNC' }]
        user = _dataest.filter(t => t.role === _userlogado)
        break
      case 'pow':
        const _datapow = [{ 'role': 'ROLE_ADM' }, { 'role': 'ROLE_POW' }]
        user = _datapow.filter(t => t.role === _userlogado)
        break
      case 'coor':
        const _datacoor = [{ 'role': 'ROLE_PED' }, { 'role': 'ROLE_ADM' }, { 'role': 'ROLE_DIR' }, { 'role': 'ROLE_COOR' }, { 'role': 'ROLE_POW' }]
        user = _datacoor.filter(t => t.role === _userlogado)
        break
      case 'func':
        const _datafunc = [{ 'role': 'ROLE_FUNC' }, { 'role': 'ROLE_PED' }, { 'role': 'ROLE_ADM' }, { 'role': 'ROLE_DIR' }, { 'role': 'ROLE_POW' }]
        user = _datafunc.filter(t => t.role === _userlogado)
        break
      case 'dir':
        const _datadir = [{ 'role': 'ROLE_ADM' }, { 'role': 'ROLE_DIR' }, { 'role': 'ROLE_POW' }]
        user = _datadir.filter(t => t.role === _userlogado)
        break
    }
    if (!user.length) {
      window.location.href = '/#/denied'
    } */
  }
}
